import { Component, ViewChild, ElementRef, ɵConsole } from "@angular/core"; import { Location } from "@angular/common";
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BlockUIModule } from 'primeng/blockui';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { LocationEntite } from 'src/app/entites/location';
import { BaseComponent } from 'src/app/base/base-component';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { ItemService } from 'src/app/services/item-service';
import { AchatService } from 'src/app/services/achat-service';
import { ReparationService } from 'src/app/services/reparation-service';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { GarantieService } from 'src/app/services/garantie-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { EStatuts } from 'src/app/entites/enums/statuts';
import { SelectionDelaiComponent } from 'src/app/controles/selection-delai.component';
import { LocationService } from 'src/app/services/location-service';

export interface ParametresConfirmerFinLocation {
    location: LocationEntite;
}

export interface ResultatConfirmerFinLocation {
    location: LocationEntite;
}

@Component({
    templateUrl: './confirmer-fin-location.component.html'
})
export class ConfirmerFinLocationComponent extends BaseComponent {

    donnees: ParametresConfirmerFinLocation;

    location: LocationEntite;

    submitted: boolean;

    constructor(
        profilService: ProfilService,
        route: ActivatedRoute, 
        routerService: Router,
		appMain: AppMainComponent, location: Location, 
        public itemService: ItemService,
        public achatService: AchatService,
        public reparationService: ReparationService,
        public fournisseurService: FournisseurService,
        private garantieService: GarantieService,
        private dialogService: DialogService,
        private locationService: LocationService,
        public messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public sdb: DonneesBaseService) {
        super(sdb, profilService, route, routerService, appMain);
    }

    ngOnInit() {

        this.donnees = this.config.data;

        this.location = this.donnees.location;

        this.CompleterChargement();
    }

    annuler() {
        this.ref.close(null);
    }

    sauvegarder() {

        this.submitted = true;
        if (!this.valider()) {
            this.messageService.add({ key: 'debutLocation', severity: 'error', summary: 'Erreurs', detail: 'Veuillez corriger les erreurs de saisie.' });
            return;
        }

        this.Bloquer();

        this.locationService.FinLocation(this.location).then(res => {
            this.Debloquer();

            if (res.estUnSucces) {
                this.location.statut = res.valeur.statut;
                this.location.coutLocation = res.valeur.coutLocation;
                this.ref.close({
                    location: this.location
                });
            } else {
               
                res.messages.forEach(x => {
                    this.messageService.add({ key: 'finLocation', severity: 'error', summary: 'Erreur', detail: x.description });
                });
            }
        });
    }

    valider() {
        return this.location.dateFin && 
        (this.location.heuresFin || this.location.heuresFin == 0) &&
        this.location.etat;
    }
}